import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../../assets/Configuration';
import { ReportIddModel } from '../models/reporting/report-idd.model';
import { ReportComplianceModel } from '../models/reporting/report-compliance.model';

@Injectable({
  providedIn: 'root',
})
export class ReportingService {
  constructor(private httpClient: HttpClient) {}

  public getIddReport(year: number): Observable<ReportIddModel[]> {
    const params = new HttpParams()
      .set('year', year);
    
    return this.httpClient.get<ReportIddModel[]>(
      Configuration.getApiBaseUrl() + `/reporting/idd-report`,
      { params: params}
    );
  }

  public getComplianceReport(year: number): Observable<ReportComplianceModel[]> {
    const params = new HttpParams()
      .set('year', year);

    return this.httpClient.get<ReportComplianceModel[]>(
      Configuration.getApiBaseUrl() + `/reporting/compliance-report`,
      { params: params}
    );
  }
}
